<template>
  <!-- <b-modal id="survey-license-modal" :visible="showModal" scrollable @hide="closeModal"
  title="Licensing Survey" hide-footer> -->
  <b-modal id="survey-license-modal" :visible="showModal" scrollable @hide="closeModal1" title="Licensing Survey" hide-footer no-close-on-backdrop>
    <!-- <template v-slot:modal-header  v-if="!productName.some(item => item.ProductName.includes('XenServer'))">
      <b-button-close @click="closeModal"></b-button-close>
    </template> -->
    <template v-slot:modal-header>
      <div>
        <h5 class="modal-title">{{ $t('Licensing Survey') }}</h5>
      </div>
      <div>
        <b-button-close @click="closeModal1"></b-button-close>
      </div>
    </template>
    <b-embed
      type="iframe"
      aspect="4by3"
      :src="getSurveyUrlBasedOnProduct"
    ></b-embed>
    <div>
      <div style="justify-content: center; align-items: center;">
        <div v-if="surveyNotCompleted" style="justify-content: center;">
          <p style="color: red">Please submit the Survey</p>
        </div>
        <div style="justify-content: right;">
          <a href="#" class="danger-text" @click="closeModal1" ref="dontShow" > <!----v-if="this.productName.some(item => item.ProductName.includes('XenServer'))">-->
            {{ $t('cancel') }}
          </a>
        </div>
      </div>
    </div>
    <div v-if="endOfSurvey">
        <h1>Success</h1>
    </div>
  </b-modal>
</template>

<script>
  import axios from 'axios'
  import { mapGetters, mapMutations } from 'vuex'
  // import { mount } from '@vue/test-utils'
  // import FetchUrl from './AllLicenses.vue'

  axios.defaults.withCredentials = false
  export default {
    name: 'SurveyModal',
    props: {
      showModal: {
        type: Boolean,
        default: false
      },
      productName: {
        type: Array,
        default: () => []
      },
      closeAction: {
        type: Function, required: true
      }
    },
    data () {
      // endOfSurvey: document.getElementById('EndOfSurvey')
      return {
        surveyNotCompleted: false
      }
      // wrapper: mount(this.SurveyModal)
    },
    computed: {
      ...mapGetters(['validSurveyData, validXSSurveyData']),
      hasXenServer () {
        return Array.isArray(this.productName) && this.productName.some(item => item.ProductName.includes('XenServer'))
      },
      authUser () {
        const authUser = JSON.parse(sessionStorage.getItem('auth_user') || JSON.stringify({}))
        authUser.perosnId ? this.sourceLink = this.sourceLink + '?PersonId=' + authUser.perosnId : this.sourceLink = this.sourceLink
        return authUser.perosnId
      },
      getSurveyUrl () {
        if (this.validSurveyData && this.validSurveyData.Url) {
          var url = this.validSurveyData.Url + '?PersonId=' + this.$store.getters.authToken.personId + '&Survey_Id=' + this.validSurveyData.Id + '&CustomerId=' + this.$store.getters.person.customerId
          return url
        }
      },
      getSurveyUrlBasedOnProduct () {
        console.log('in Survey productName', this.productName)
        // let hasXenServer = this.productName.some(item => item.ProductName.includes('XenServer'))
        console.log('in Survey hasXenServer', this.hasXenServer)
        console.log('this.validSurveyData: ', this.validSurveyData)
        if (this.hasXenServer) {
          console.log('xsUrl', this.$store.getters.xsSurveyUrl)
          if (this.$store.getters.xsSurveyUrl) { // (this.validXSSurveyData && this.validXSSurveyData.Url) {
            console.log('xsUrl in Survey Modal', this.$store.getters.xsSurveyUrl)
            var Xsurl = this.$store.getters.xsSurveyUrl + '?PersonId=' + this.$store.getters.authToken.personId + '&SurveyId=' + this.$store.getters.xsSurveyId + '&CustomerId=' + this.$store.getters.person.customerId
            console.log('fina lxsUrl in Survey Modal', Xsurl)
            return Xsurl
          }
        } else {
          console.log('validSurveyData.Url', this.$store.getters.surveyUrl)
          var url = this.$store.getters.surveyUrl + '?PersonId=' + this.$store.getters.authToken.personId + '&SurveyId=' + this.$store.getters.surveyId + '&CustomerId=' + this.$store.getters.person.customerId
          console.log('url', url)
          return url
        }
        // } else if (this.validSurveyData && this.validSurveyData.Url) {
        //   console.log('validSurveyData.Url', this.validSurveyData.Url)
        //   var url = this.validSurveyData.Url + '?PersonId=' + this.$store.getters.authToken.personId + '&SurveyId=' + this.validSurveyData.Id + '&CustomerId=' + this.$store.getters.person.customerId
        //   console.log('url', url)
        //   return url
        // }
      }
    },
    methods: {
      ...mapMutations([
        'SHOW_SURVEY_MODAL',
        'SHOW_SURVEY_MODAL_XS',
        'SURVEY_MODAL_CLOSED',
        'SURVEY_MODAL_CLOSED_XS'
      ]),
      closeModal1 () {
        console.log('this.productName: ', this.productName)
        console.log('this.productName: ', this.productName.length)
        if (this.hasXenServer && this.productName.length > 0) {
          console.log('endOfSurvey XenServer')
          this.checkIfSurveySubmitted()
            .then(isSurveySubmitted => {
              if (isSurveySubmitted) {
                this.SURVEY_MODAL_CLOSED_XS(true)
                this.SHOW_SURVEY_MODAL(false)
                this.SHOW_SURVEY_MODAL_XS(false)
                this.closeAction(true)
              } else {
                this.surveyNotCompleted = true
              }
            })
            .catch(error => {
              console.error('Error checking survey submission:', error)
              this.surveyNotCompleted = true
            })
        } else {
          console.log('endOfSurvey')
          this.handelSurveyDisplay()
          this.SURVEY_MODAL_CLOSED(true)
          this.SHOW_SURVEY_MODAL(false)
          this.SHOW_SURVEY_MODAL_XS(false)
          this.closeAction(false)
        }
      },
      print () {
        console.log('endOfSurvey', this.endOfSurvey)
      },
      handelSurveyDisplay () {
        const headers = {
          apiKey: this.UrlBuilder.surveyAPIKey
        }
        axios.post(this.UrlBuilder.surveyTransactionAPIUrl, {
          PersonId: this.$store.getters.authToken.personId,
          SurveyId: this.$store.getters.surveyId,
          CustomerId: this.$store.getters.person.customerId
        }, {
          headers: headers
        })
        .then(({ data }) => {
          if (data) {
            console.log('Don\'t Show Survey Success!')
          } else {
            console.log('Don\'t Show Survey Failure!')
          }
        })
        .catch((error) => {
          this.loggly.log({
            errorMessage: `Failed `,
            errorObject: error,
            errorStack: error.stack
          })
        })
      },
      checkIfSurveySubmitted () {
        const headers = {
          apiKey: this.UrlBuilder.surveyAPIKey
        }
        return axios.post(this.UrlBuilder.surveyAPIUrl, {
          PersonId: this.$store.getters.authToken.personId,
          ApplicationName: this.UrlBuilder.surveyAppName,
          Action: 'XSAllocate'
        }, {
          headers: headers
        })
        .then(({ data }) => {
          if (data && data.Url) {
            return false
          } else {
            return true
          }
        })
        .catch((error) => {
          this.loggly.log({
            errorMessage: `Failed `,
            errorObject: error,
            errorStack: error.stack
          })
          return false
        })
      }
    }
  }
</script>


<style lang="scss">
  @import '../styles/variables.scss';

</style>




// WEBPACK FOOTER //
// src/components/SurveyModal.vue